import { Box, Stack, StackProps } from "@chakra-ui/react";
import { ReactNode } from "react";

interface ICardLayout extends StackProps {
  topImage: ReactNode;
  content: ReactNode;
}

const CardLayout: React.FC<ICardLayout> = ({ content, topImage, ...props }) => (
  <Stack
    direction="column"
    width="260px"
    overflow="hidden"
    borderRadius="6px"
    backgroundColor="ud-grey-200"
    boxShadow="0 4px 8px 0 rgba(0, 0, 0, 0.2)"
    transition="all 0.2s"
    _hover={{
      boxShadow: "0 8px 16px 0 rgba(0, 0, 0, 0.2)",
      backgroundColor: "white",
    }}
    role="group"
    spacing="10px"
    {...props}
  >
    <Box
      position="relative"
      h="200px"
      _groupHover={{ opacity: "0.8" }}
      transition="all 0.2s"
    >
      {topImage}
    </Box>
    <Stack
      flex={1}
      spacing={0}
      direction="column"
      p="0 20px 20px"
      align="center"
      justify="space-between"
    >
      {content}
    </Stack>
  </Stack>
);

export default CardLayout;
